import React from 'react';
import {
  Routes,
  Route,
} from "react-router-dom";
import {  TreningP, PlanyTD, Współpraca, Hom } from './container';
import './App.css';

const App = () => (
  <>
   <Routes>
    <Route exact path='/' element={<Hom />} />
    <Route exact path='/TreningPersonalny' element={<TreningP />} />
    <Route exact path='/Współpraca' element={<Współpraca />} />
    <Route exact path='/PlanyTD' element={<PlanyTD />} />
   </Routes>
    
  </>
);

export default App;